export const LIVE_SERVICE_NAMES = {
    // CR APIs Search
    getChangeRequestSearchGrid: 'getChangeRequestSearchGrid',
    getChangeRequestSearchExportGrid: 'getChangeRequestSearchExportGrid',
    getChangeRequestDropdownValues: '/getChangeRequestDropdownValues',
    getCloseoutCRDetailsGrid: 'getCloseoutCRDetailsGrid',
    getZipcodeChangeRequestExport: 'getZipcodeChangeRequestExport',
    fetchAddNewHCPCRDoc: 'fetchAddNewHCPCRDoc',
    fetchSpecialtyExceptionCRDoc: 'fetchSpecialtyExceptionCRDoc',

    //CR APIs Details
    getChangeRequestBasicDetails: 'getChangeRequestBasicDetails',
    getMovedPhysicianCRDetails: 'getMovedPhysicianCRDetails',
    getAllocationChangeCRDetails: 'getAllocationChangeCRDetails',
    getAddNewAccountGroupCRDetails: 'getAddNewAccountGroupCRDetails',
    getAddNewPhysicianCRDetails: 'getAddNewPhysicianCRDetails',
    getUpdateAGPhysicianAffiliationCRDetails: 'getUpdateAGPhysicianAffiliationCRDetails',
    getPhysicianCloseoutCRDetails: 'getPhysicianCloseoutCRDetails',
    getPhysicianIndicationBreakoutCRDetails: 'getPhysicianIndicationBreakoutCRDetails',
    getPhysicianUsageEstimationChangeCRDetails: 'getPhysicianUsageEstimationChangeCRDetails',
    getShiptoCloseoutCRDetails: 'getShiptoCloseoutCRDetails',
    getSuggestZipAlignmentUpdateCRDetails: 'getSuggestZipAlignmentUpdateCRDetails',
    getUpdateNeuroSpecialtyExceptionCRDetails: 'getUpdateNeuroSpecialtyExceptionCRDetails',
    getUpdatePhysicianSppAlignmentCRDetails: 'getUpdatePhysicianSppAlignmentCRDetails',
    getUpdateSplitPercentageCRDetails: 'getUpdateSplitPercentageCRDetails',
    getUpdateTeamExclusionCRDetails: 'getUpdateTeamExclusionCRDetails',
    getUpdateUroSpecialtyExceptionCRDetails: 'getUpdateUroSpecialtyExceptionCRDetails',
    getUpdateAGShiptoAffiliationCRDetails: 'getUpdateAGShiptoAffiliationCRDetails',
    getRemoveRetiredFlagCRDetails: 'getRemoveRetiredFlagCRDetails',
    getUpdateAGProfileCRDetails: 'getUpdateAGProfileCRDetails',
    getUpdateDirectAlignmentChangeCRDetails: 'getUpdateDirectAlignmentChangeCRDetails',
    getVialArbitrationCRDetails: 'getVialArbitrationCRDetails',
    getTeamGeoSplitCRDetails: '/getTeamGeoSplitCRDetails',
    getChangeRequestGenericWorkflow: '/getChangeRequestGenericWorkflow',

    getChangeRequestActivity: 'getChangeRequestActivity',
    getChangeRequestNotes: 'getChangeRequestNotes',
    getRejectReasonDropdownValues: 'getRejectReasonDropdownValues',
    getAssignUserDropdownValues: 'getAssignUserDropdownValues',
    assignCRToSoUser: 'assignCRToSoUser',

    //CR APIs submit
    createChangeRequest: 'createChangeRequest',
    uploadSpecialtyExceptionFile: 'uploadSpecialtyExceptionFile',
    uploadAddNewHCPFile: 'uploadAddNewHCPFile',

    //CR Edit
    editChangeRequest: 'editChangeRequest',

    //CR Return to submitter
    changeRequestReturntoSubmitter: 'changeRequestReturntoSubmitter',

    //CR APIs approve/reject
    approveChangeRequest: 'approveChangeRequest',
    rejectChangeRequest: 'rejectChangeRequest',
    forceRejectChangeRequest: 'forceRejectChangeRequest',

    //APIs Search
    getStateDropDownValues: 'getStateDropDownValues',
    getOutletSearchGrid: 'getOutletSearchGrid',
    getOutletDetails: 'getOutletDetails',
    getGeographyExportUnitsGrid: 'getGeographyExportUnitsGrid',
    getOutletExportDetailsGrid: 'getOutletExportDetailsGrid',

    //Shipto APIs
    getShiptoSearchFilters: 'getShiptoSearchFilters',
    getShiptoSearchGrid: 'getShiptoSearchGrid',
    getShiptoSearchExportGrid: 'getShiptoSearchExportGrid',
    getShiptoRecentSalesSearchGrid: 'getShiptoRecentSalesSearchGrid',
    getShiptoNewAccountExceptionSearchGrid: 'getShiptoNewAccountExceptionSearchGrid',
    getTimePeriodShipToPUE: 'getTimePeriodShipToPUE',
    getShiptoAllocation: 'getShiptoAllocation',
    getShiptoSalesFilters: 'getShiptoSalesFilters',
    getShiptoSales: 'getShiptoSales',
    getShiptoBnBSales: 'getShiptoBnBSales',
    getShiptoCurrentAllocation: 'getShiptoCurrentAllocation',
    getPhysicianUsageEstimates: 'getPhysicianUsageEstimates',
    getAttainmentUniverseDetails: 'getAttainmentUniverseDetails',
    getReportingAgGrid: 'getReportingAgGrid',
    getPUECRGridDetails: 'getPUECRGridDetails',
    getDAComplicaneCycleDetails: 'getDAComplicaneCycleDetails',
    getUpdateTeamExclusion: 'getUpdateTeamExclusion',
    getshipToSplitBuckets: 'getshipToSplitBuckets',
    getShiptoBasicDetails: 'getShiptoBasicDetails',
    getShiptoCloseoutDetails: 'getShiptoCloseoutDetails',
    getShiptoCompEligibilityDetails: 'getShiptoCompEligibilityDetails',
    getTranseferVialsFromShiptoDetails: 'getTranseferVialsFromShiptoDetails',
    getCopyPUEShiptoAllocation: 'getCopyPUEShiptoAllocation',
    getTeamGeoSplitDetails: 'getTeamGeoSplitDetails',
    getTeamGeoSplitCRDetailsForDA: 'getTeamGeoSplitCRDetailsForDA',

    //Physican APIs
    getPhysicianSearchFilters: 'getPhysicianSearchFilters',
    getPhysicianSearchGrid: 'getPhysicianSearchGrid',
    getPhysicianBasicDetails: 'getPhysicianBasicDetails',
    getPhysicianActiveAllocations: 'getPhysicianActiveAllocations',
    getPhysicianAgAffiliation: 'getPhysicianAgAffiliation',
    getPhysicianAllSpecialities: 'getPhysicianAllSpecialities',
    getPhysicianApprovedSpecialty: 'getPhysicianApprovedSpecialty',
    getPhysicianAttainmentUniverseDetails: 'getPhysicianAttainmentUniverseDetails',
    getPhysicianSPPZipAlignmentGrid: 'getPhysicianSPPZipAlignmentGrid',
    getPhysicianCallFileStatus: 'getPhysicianCallFileStatus',
    getPhysicianSalesFilters: 'getPhysicianSalesFilters',
    getPhysicianSales: 'getPhysicianSales',
    getPhysicianBnBSales: 'getPhysicianBnBSales',
    getPhysicianSPPSales: 'getPhysicianSPPSales',
    getPhysicianSearchExportGrid: 'getPhysicianSearchExportGrid',
    getAddNewPhysicianCRFormFilters: '/getAddNewPhysicianCRFormFilters',
    getSPPComplianceCycleDetails: 'getSPPComplianceCycleDetails',
    getPhysicianCloseoutDetails: '/getPhysicianCloseoutDetails',
    getPhysicianBaselineFlag: '/getPhysicianBaselineFlag',

    //AG APIs
    getAccountGroupSearchFilters: 'getAccountGroupSearchFilters',
    getAccountGroupSearchGrid: 'getAccountGroupSearchGrid',
    getAccountGroupDetails: 'getAccountGroupDetails',
    getAccountGroupShiptoAffiliation: 'getAccountGroupShiptoAffiliation',
    getAccountGroupPhysicianAffiliation: 'getAccountGroupPhysicianAffiliation',

    //ZipCode
    getZipcodeSearchGrid: 'getZipcodeSearchGrid',
    getZipcodeSearchExport: 'getZipcodeSearchExport',
    
    //Shared APIs
    getUserDetails: 'getUserInfo',
    fetchDocumentDetails: 'getDocuments',
    fetchHelpPageDetails: 'fetchHelpPageDetails',
    uploadDocument: 'uploadDocument',
    fetchDocuments: 'fetchDocuments',
    removeDocument: 'removeDocument',
    getTeamGeographySearchMap: 'getTeamGeographySearchMap',
    getHistoryOfChanges: 'getHistoryOfChanges',
    sendDeveloperErrorMail: 'sendDeveloperErrorMail',
    getCityStateInfoFromZipcode: 'getCityStateInfoFromZipcode',
    getCurrentPendingCRs: 'getCurrentPendingCRs',
    getAddOrViewNotes: 'getAddOrViewNotes',
    createAddOrViewNote: 'createAddOrViewNote',
    getPendingChangeRequestCount: 'getPendingChangeRequestCount',
    getChatbotResponse: 'getChatbotResponse'
};


